import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
// FIXME boundaries
// tslint:disable-next-line:nx-enforce-module-boundaries

@Component({
  selector: 'atx-date-picker-navigation',
  templateUrl: './date-picker-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DatePickerNavigationComponent {
  @Output() public previous = new EventEmitter();
  @Output() public next = new EventEmitter();
  @Output() public titleClick = new EventEmitter();
}
